import { type Blocker, useBlocker } from 'react-router'
import { useCallback, useEffect } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { AgentBookAppointmentStepsRoutes } from 'pages/chatbot/pages/agentBookAppointment'

type IUseBookAppointmentBlockerProps = {
  isExistChanges: boolean
  confirmLeavePage: (blocker: Blocker) => void
}

export const useBookAppointmentBlocker = ({
  isExistChanges,
  confirmLeavePage,
}: IUseBookAppointmentBlockerProps) => {
  const blocker = useBlocker((location) => {
    const isBookAppointmentPath = Object.values(AgentBookAppointmentStepsRoutes).some((url) =>
      location.nextLocation.pathname.includes(url)
    )

    return isExistChanges && !isBookAppointmentPath
  })

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [])

  useEffect(() => {
    uiStore.setRoutesBlocker(blocker)
    confirmLeavePage(blocker)
  }, [blocker])

  useEffect(() => {
    if (isExistChanges) {
      window.addEventListener('beforeunload', beforeUnloadHandler)
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [isExistChanges])
}
